import { HOLD_UNTIL_REPLY_SWITCH_CAMPAIGN_MODAL } from 'modules/workflows/constants/modals';
import { Button, BUTTON_VARIANTS } from 'ui/button';
import { Modal, MODAL_SIZES, MODAL_VARIANTS, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

type Props = {
  isOpen: boolean;
  handleSwitch: () => void;
  onClose: () => void;
};

export const content = {
  deleteButton: 'Switch',
};

export const HoldUntilReplySwitchCampaignModal = ({ isOpen, handleSwitch, onClose }: Props) => {
  return (
    <Modal
      id={HOLD_UNTIL_REPLY_SWITCH_CAMPAIGN_MODAL}
      isModalOpen={isOpen}
      onClose={onClose}
      variant={MODAL_VARIANTS.WARNING}
      size={MODAL_SIZES.SMALL}
    >
      <ModalHeader>Switch to another campaign</ModalHeader>
      <ModalBody>
        Are you sure you want to switch to another campaign? Any edits you've manually set up will
        be lost.
      </ModalBody>
      <ModalFooter>
        <Button autoFocus onClick={handleSwitch} variant={BUTTON_VARIANTS.DESTRUCTIVE}>
          {content.deleteButton}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
